(function () {
  var PROXY_BASE = 'https://diamondsforeveryone.com.au/apps/nivoda';
  var STORAGE_KEY = 'rb_active_diamond_products';
  var PENDING_KEY = 'rb_pending_cleanup';
  var cleanupInFlight = {};
  var lastKnownDiamondIds = [];

  function isSettingItem(item) {
    var props = item.properties || {};
    return Boolean(props.setting_sku || props['Ring Size']);
  }

  function isDiamondItem(item) {
    if (String(item.vendor || '').toLowerCase() === 'nivoda') return true;
    var props = item.properties || {};
    return Boolean(props._product_id || props['Diamond Certificate']);
  }

  function builderIdOf(item) {
    return item.properties && item.properties._builder_id
      ? String(item.properties._builder_id)
      : '';
  }

  function getNivodaProductId(item) {
    if (!item) return '';
    if (String(item.vendor || '').toLowerCase() === 'nivoda') {
      return String(item.product_id || '');
    }
    var props = item.properties || {};
    return props._product_id ? String(props._product_id) : '';
  }

  function getDiamondProductIds(cart) {
    var ids = [];
    if (!cart || !cart.items) return ids;
    cart.items.forEach(function (item) {
      var productId = getNivodaProductId(item);
      if (productId) ids.push(productId);
    });
    return ids;
  }

  function loadStoredIds() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function saveStoredIds(ids) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
    } catch (e) {}
  }

  function loadPendingIds() {
    try {
      return JSON.parse(localStorage.getItem(PENDING_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function savePendingIds(ids) {
    try {
      localStorage.setItem(PENDING_KEY, JSON.stringify(ids));
    } catch (e) {}
  }

  function trackProductId(productId) {
    if (!productId) return;
    var pid = String(productId);
    var ids = loadStoredIds();
    if (ids.indexOf(pid) === -1) {
      ids.push(pid);
      saveStoredIds(ids);
    }
  }

  function queuePendingCleanup(productId) {
    if (!productId) return;
    var pid = String(productId);
    var pending = loadPendingIds();
    if (pending.indexOf(pid) === -1) {
      pending.push(pid);
      savePendingIds(pending);
    }
  }

  function cleanupProduct(productId) {
    if (!productId || cleanupInFlight[productId]) return Promise.resolve();
    cleanupInFlight[productId] = true;

    return fetch(PROXY_BASE + '/diamond/cleanup-product', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ product_id: parseInt(productId, 10) }),
    })
      .then(function (response) {
        return response.json().then(function (payload) {
          if (!response.ok) {
            throw new Error((payload && payload.error) || 'Cleanup failed');
          }
          var stored = loadStoredIds().filter(function (id) {
            return id !== String(productId);
          });
          saveStoredIds(stored);
          var pending = loadPendingIds().filter(function (id) {
            return id !== String(productId);
          });
          savePendingIds(pending);
          return payload;
        });
      })
      .catch(function () {
        queuePendingCleanup(productId);
      })
      .finally(function () {
        delete cleanupInFlight[productId];
      });
  }

  function flushPendingCleanup() {
    var pending = loadPendingIds();
    if (!pending.length) return;
    pending.forEach(cleanupProduct);
  }

  function builderIdsWithSetting(cart) {
    var ids = {};
    if (!cart || !cart.items) return ids;
    cart.items.forEach(function (item) {
      if (!isSettingItem(item)) return;
      var builderId = builderIdOf(item);
      if (builderId) ids[builderId] = true;
    });
    return ids;
  }

  function findOrphanDiamondLine(cart) {
    if (!cart || !cart.items) return null;
    var settings = builderIdsWithSetting(cart);
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (!isDiamondItem(item)) continue;
      var builderId = builderIdOf(item);
      if (builderId && !settings[builderId]) {
        return {
          line: i + 1,
          productId: getNivodaProductId(item),
        };
      }
    }
    return null;
  }

  function cleanupRemovedDiamonds(previousIds, currentIds) {
    var seen = {};
    previousIds.forEach(function (productId) {
      if (!productId || seen[productId]) return;
      seen[productId] = true;
      if (currentIds.indexOf(productId) === -1) {
        cleanupProduct(productId);
      }
    });

    loadStoredIds().forEach(function (productId) {
      if (!productId || seen[productId]) return;
      seen[productId] = true;
      if (currentIds.indexOf(productId) === -1) {
        cleanupProduct(productId);
      }
    });
  }

  function syncTrackedIds(currentIds) {
    saveStoredIds(currentIds);
    lastKnownDiamondIds = currentIds.slice();
  }

  function processCart(cart) {
    if (!cart || typeof cart.item_count === 'undefined') {
      return Promise.resolve();
    }

    var currentIds = getDiamondProductIds(cart);
    var orphan = findOrphanDiamondLine(cart);

    if (orphan) {
      if (orphan.productId) {
        cleanupProduct(orphan.productId);
      }
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ line: orphan.line, quantity: 0 }),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (updatedCart) {
          var updatedIds = getDiamondProductIds(updatedCart);
          cleanupRemovedDiamonds(lastKnownDiamondIds, updatedIds);
          syncTrackedIds(updatedIds);
          return processCart(updatedCart);
        })
        .catch(function () {
          cleanupRemovedDiamonds(lastKnownDiamondIds, currentIds);
          syncTrackedIds(currentIds);
        });
    }

    cleanupRemovedDiamonds(lastKnownDiamondIds, currentIds);
    syncTrackedIds(currentIds);
    return Promise.resolve();
  }

  function onCartMaybeUpdated(cart) {
    if (cart && typeof cart.item_count !== 'undefined') {
      processCart(cart);
      return;
    }
    fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(processCart)
      .catch(function () {});
  }

  function isCartMutationUrl(url) {
    if (!url) return false;
    return (
      url.indexOf('/cart/change') !== -1 ||
      url.indexOf('/cart/update') !== -1 ||
      url.indexOf('/cart/clear') !== -1 ||
      url.indexOf('/cart/add') !== -1
    );
  }

  function parseCartJsonPayload(text) {
    if (!text) return null;
    try {
      var cart = JSON.parse(text);
      if (cart && typeof cart.item_count !== 'undefined' && cart.items) {
        return cart;
      }
      if (cart && cart.items) {
        return cart;
      }
    } catch (e) {}
    return null;
  }

  function bindDawnCartIntegration() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.cartData) {
          onCartMaybeUpdated(event.cartData);
        } else {
          onCartMaybeUpdated();
        }
      });
    }

    if (!window.__rbCartFetchPatched && typeof window.fetch === 'function') {
      window.__rbCartFetchPatched = true;
      var nativeFetch = window.fetch.bind(window);

      window.fetch = function (input, init) {
        var url = '';
        if (typeof input === 'string') {
          url = input;
        } else if (input && typeof input.url === 'string') {
          url = input.url;
        }

        return nativeFetch(input, init).then(function (response) {
          if (!isCartMutationUrl(url)) {
            return response;
          }

          return response
            .clone()
            .text()
            .then(function (text) {
              var cart = parseCartJsonPayload(text);
              if (cart) {
                onCartMaybeUpdated(cart);
              } else {
                onCartMaybeUpdated();
              }
            })
            .catch(function () {
              onCartMaybeUpdated();
            })
            .then(function () {
              return response;
            });
        });
      };
    }
  }

  function parseRemoveLink(link) {
    var href = link.getAttribute('href') || '';
    var lineMatch = href.match(/[?&]line=(\d+)/);
    var qtyMatch = href.match(/[?&]quantity=(\d+)/);
    if (!lineMatch || !qtyMatch || qtyMatch[1] !== '0') return null;
    return {
      line: parseInt(lineMatch[1], 10),
      nivodaProductId: link.getAttribute('data-nivoda-product-id') || '',
    };
  }

  function removeCartLine(line, knownNivodaProductId) {
    return fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var item = cart.items[line - 1];
        var nivodaProductId =
          knownNivodaProductId || getNivodaProductId(item) || '';
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ line: line, quantity: 0 }),
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (updatedCart) {
            if (nivodaProductId) {
              cleanupProduct(nivodaProductId);
            }
            return processCart(updatedCart).then(function () {
              return updatedCart;
            });
          });
      });
  }

  function bindRemoveLinks() {
    document.addEventListener(
      'click',
      function (event) {
        var miniBtn = event.target.closest('.js-remove-mini-cart');
        if (miniBtn) {
          var line = parseInt(miniBtn.getAttribute('data-line'), 10);
          if (!line) return;
          event.preventDefault();
          event.stopImmediatePropagation();

          fetch('/cart.js')
            .then(function (response) {
              return response.json();
            })
            .then(function (cart) {
              var item = cart.items[line - 1];
              var nivodaProductId = getNivodaProductId(item) || '';
              return removeCartLine(line, nivodaProductId);
            })
            .then(function () {
              if (window.theme && window.theme.miniCart) {
                if (typeof window.theme.miniCart.updateElements === 'function') {
                  window.theme.miniCart.updateElements();
                }
                if (typeof window.theme.miniCart.generateCart === 'function') {
                  window.theme.miniCart.generateCart();
                }
              }
              if (window.location.pathname.indexOf('/cart') === 0) {
                window.location.reload();
              }
            })
            .catch(function () {
              window.location.reload();
            });
          return;
        }

        var link = event.target.closest('a[href*="/cart/change"]');
        if (!link) return;

        var parsed = parseRemoveLink(link);
        if (!parsed) return;

        event.preventDefault();
        event.stopPropagation();

        removeCartLine(parsed.line, parsed.nivodaProductId)
          .then(function () {
            if (window.location.pathname.indexOf('/cart') === 0) {
              window.location.reload();
              return;
            }
            if (window.theme && window.theme.miniCart) {
              if (typeof window.theme.miniCart.updateElements === 'function') {
                window.theme.miniCart.updateElements();
              }
              if (typeof window.theme.miniCart.generateCart === 'function') {
                window.theme.miniCart.generateCart();
              }
            }
          })
          .catch(function () {
            if (parsed.nivodaProductId) {
              queuePendingCleanup(parsed.nivodaProductId);
            }
            window.location.href = link.getAttribute('href');
          });
      },
      true,
    );
  }

  function init() {
    flushPendingCleanup();

    fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        lastKnownDiamondIds = getDiamondProductIds(cart);
        return processCart(cart);
      })
      .catch(function () {});

    bindRemoveLinks();
    bindDawnCartIntegration();

    if (typeof jQuery !== 'undefined') {
      jQuery(document).ajaxComplete(function (event, xhr, settings) {
        var url = (settings && settings.url) || '';
        if (!isCartMutationUrl(url)) return;
        var cart = xhr.responseJSON;
        if (!cart && xhr.responseText) {
          try {
            cart = JSON.parse(xhr.responseText);
          } catch (e) {
            cart = null;
          }
        }
        onCartMaybeUpdated(cart);
      });
    }

    window.addEventListener('pageshow', function () {
      flushPendingCleanup();
      fetch('/cart.js')
        .then(function (response) {
          return response.json();
        })
        .then(processCart)
        .catch(function () {});
    });
  }

  window.RingBuilderCartCleanup = {
    trackProductId: trackProductId,
    processCart: processCart,
    cleanupProduct: cleanupProduct,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
